import {CustomRoleFeatureKeys} from 'src/security/customRoleFeatureKeys';

/**
 * Editar tarea en estado Cerrada: permiso legacy `tareaEditClosed` (id `taskEdit` / rol `taskEdit`)
 * o capacidad `taskEditClosed` en rol custom.
 * Alineado con stem-web-backend `canEditClosedTask` (`EDIT_CLOSED_ROLES` + feature).
 */
const EDIT_CLOSED_FIXED_ROLES = [
  'admin',
  'administrador',
  'administradorOperaciones',
  'taskEdit',
] as const;

export function canUseTaskEditClosedForUi(
  hasPermissionTareaEditClosed: boolean,
  featureKeys: readonly string[],
  tenantAccessContextLoadStatus: 'loaded' | 'failed' | null | undefined,
  roles?: readonly string[],
): boolean {
  if (hasPermissionTareaEditClosed) {
    return true;
  }
  if (roles?.some((r) => (EDIT_CLOSED_FIXED_ROLES as readonly string[]).includes(r))) {
    return true;
  }
  if (tenantAccessContextLoadStatus === 'failed') {
    return false;
  }
  return featureKeys.includes(CustomRoleFeatureKeys.taskEditClosed);
}
